module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/8-4a07d2e8ed66ed19b11469b31e261aba.png";